import React from 'react';
import { Heart } from 'lucide-react';
import { imageData, getAltText } from '../../data/images';

const AboutSection = ({ language, currentContent }) => {
  const { aboutImages } = imageData;

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-dancing">
            {currentContent.about.title}
          </h2>
          <p className="text-xl text-tilcara-orange font-medium mb-4">
            {currentContent.about.subtitle}
          </p>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {currentContent.about.humanSubtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              {currentContent.about.description}
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              {currentContent.about.story}
            </p>
            
            <div className="space-y-4">
              {currentContent.about.features.map((feature, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <Heart className="h-5 w-5 text-tilcara-orange flex-shrink-0" />
                  <span className="text-gray-700">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {aboutImages.map((image, index) => (
              <img
                key={index}
                src={image.src}
                alt={getAltText(image, language)}
                className={`rounded-lg shadow-lg gallery-item hover:scale-105 transition-transform duration-300 ${
                  index % 2 === 1 ? 'mt-8' : ''
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
